import React from 'react';
import CheckinGuide from '../../Owner/CheckinGuide/CheckinGuide';

const ExperienceGuides = () => {
    return <CheckinGuide />;
};

export default ExperienceGuides;
